import {
  GET_CUSTOMER_SERVICE_SUCCESS,
  GET_CUSTOMER_SERVICE_FAIL,
  ADD_CUSTOMER_SERVICE_SUCCESS,
  ADD_CUSTOMER_SERVICE_FAIL,
  UPDATE_CUSTOMER_SERVICE_SUCCESS,
  UPDATE_CUSTOMER_SERVICE_FAIL,
  DELETE_CUSTOMER_SERVICE_SUCCESS,
  DELETE_CUSTOMER_SERVICE_FAIL,
  SHOW_LOADING,
  HIDE_LOADING,
} from "./actionTypes"

const INIT_STATE = {
  custService: [],
  managers: [],
  loading: false,
  error: null,
}

const customerService = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CUSTOMER_SERVICE_SUCCESS:
      return {
        ...state,
        custService: action.payload[0],
        managers: action.payload[1],
      }
    case GET_CUSTOMER_SERVICE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_CUSTOMER_SERVICE_SUCCESS:
      return {
        ...state,
        custService: [...state.custService, action.payload],
        success: { data: "success" },
      }
    case ADD_CUSTOMER_SERVICE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_CUSTOMER_SERVICE_SUCCESS:
      return {
        ...state,
        custService: state.custService.map(service =>
          service._id.toString() === action.payload._id.toString()
            ? { service, ...action.payload }
            : service
        ),
        success: { data: "success" },
      }
    case UPDATE_CUSTOMER_SERVICE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_CUSTOMER_SERVICE_SUCCESS:
      return {
        ...state,
        custService: state.custService.filter(
          service => service._id.toString() !== action.payload._id.toString()
        ),
      }
    case DELETE_CUSTOMER_SERVICE_FAIL:
      return {
        ...state,
        error: action.payload,
      } 

    case SHOW_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    case HIDE_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    default:
      return state
  }
}

export default customerService
